/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useUser } from "../../UserProvider";
import { FaDownload, FaSpinner, FaTimes } from "react-icons/fa";
import { Contest } from "../../types/contest";
import { hasPermission } from "../../Utils";
import { ContestEditPopup } from "../../components/contests/EditContestPopup";


export const Contests = () => {
  const [logged, setLogged] = useState(false);
  const [loading, setLoading] = useState(true);
  const [contests, setContests] = useState<Contest[]>([])

  const [editingContest, setEditingContest] = useState<Contest | undefined>(undefined);
  const [isEditingContest, setIsEditingContest] = useState<boolean>(false);


  const userProvider = useUser();

  useEffect(() => {
    if (userProvider.user !== null) setLogged(true)
  }, [])

  useEffect(() => {
    fetch(process.env.REACT_APP_API_URL + "/contests", {
      method: "GET"
    })
      .then(res => {
        if (!res.ok) throw new Error("Fetch error");
        return res.json();
      })
      .then((data: Contest[]) => {
        setContests(data)
        console.log(data)
      })
      .catch(() => {
        setContests([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [])


  function downloadAllSubmissions(e: React.MouseEvent<SVGElement>, contest: Contest) {
    e.preventDefault();
    e.stopPropagation();

    fetch(process.env.REACT_APP_API_URL + `/contest/${contest.id}/submissions/download`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${localStorage.getItem("authToken")}`
      }
    })
      .then(res => {
        if (!res.ok) throw new Error("Fetch error");
        return res.blob();
      })
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${contest.name}_submissions.zip`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch(() => {
        console.error("Download error");
      });
  }

  if (!logged) {
    return (
      <div className="w-full h-64 flex flex-col items-center justify-center text-red-600">
        <FaTimes className="size-32" />
        <div className="text-gray-600 dark:text-gray-400">
          <span className="animate-pulse">You need to be logged to access this page !</span>
        </div>
      </div>
    )
  }

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40 text-gray-600 dark:text-gray-400">
        <FaSpinner className="animate-spin mr-2" />
        <span>Loading…</span>
      </div>
    )
  }



  return (
    <div className="w-full max-w-screen-xl mx-auto px-4 py-10 text-gray-800 dark:text-white">
      {isEditingContest && <ContestEditPopup contest={editingContest} onClose={() => { setEditingContest(undefined); setIsEditingContest(false) }} />}
      <h1 className="text-3xl font-bold text-center mb-6 ">
        Available Contests
      </h1>
      <div>
        {contests.length === 0 ? (
          <div className="text-center text-gray-600 dark:text-gray-400">
            No contests available at the moment.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {contests.map((contest) => {
              const tags = contest.tags || [];
              const now = new Date();
              const openAt = new Date(contest.submissions_open);
              const endAt = new Date(contest.end_at);
              const isUpcoming = openAt > now;
              const isEnded = endAt < now;
              const status = isEnded ? "Ended" : isUpcoming ? "Upcoming" : "In progress";
              const badgeColor = isEnded ? "bg-gray-200 text-gray-700 dark:bg-gray-800 dark:text-gray-300" : isUpcoming ? "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200" : "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200";

              return (
                <div key={contest.id} className="border rounded-xl p-5 hover:shadow-lg transition-shadow duration-300 bg-white/60 dark:bg-gray-900/60 backdrop-blur-sm">
                  <div className="flex items-start justify-between gap-3">
                    <h2 className="text-xl font-semibold leading-snug">{contest.name}</h2>
                    <span className={`px-2.5 py-1 text-xs rounded-full whitespace-nowrap ${badgeColor}`}>{status}</span>
                  </div>
                  <p className="text-sm mt-2 mb-2 line-clamp-3">{contest.description}</p>
                  {tags.length > 0 && (
                    <div className="flex flex-wrap gap-2 mb-2">
                      {tags.map((tag, index) => (
                        <span key={index} className="bg-green-500 text-white px-3 py-1 rounded-full text-sm">{tag}</span>
                      ))}
                    </div>
                  )}

                  <div className="space-y-1 text-sm text-gray-600 dark:text-gray-400">
                    {!isEnded && (
                      <p>{isUpcoming ? ("Submissions open: " + openAt.toLocaleString()) : "Submissions open"}</p>
                    )}
                    <p>{isEnded ? "Ended" : ("End: " + endAt.toLocaleString())}</p>
                  </div>

                  <div className="mt-4 flex items-center gap-2">
                    <a href={`/contest/${contest.id}`} className="inline-flex items-center justify-center bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition-colors duration-300">View Contest</a>
                    {hasPermission(userProvider.user!, 2) && (
                      <button onClick={e => { setEditingContest(contest); setIsEditingContest(true) }} className="inline-flex items-center justify-center bg-blue-600 text-white px-3 py-2 rounded-md hover:bg-blue-700 transition-colors duration-300">Edit</button>
                    )}
                    {hasPermission(userProvider.user!, 2) && (
                      <FaDownload onClick={e => downloadAllSubmissions(e, contest)} className="inline-flex items-center justify-center bg-blue-600 text-white size-10 p-3 rounded-md hover:bg-blue-700 transition-colors duration-300 cursor-pointer" />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {hasPermission(userProvider.user!, 2) && <button onClick={e => { setIsEditingContest(true) }} className="mt-6 inline-flex items-center bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition-colors duration-300">Create a Contest</button>}
      </div>
    </div>
  );
};